module.exports = __webpack_public_path__ + "img/jimmy-pro.3d6607e0.jpg";